export default {
  appointmentManagement: (state) => state,
  results: (state) => state.results,
};
